import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/custompagination";
import Sorting from "../../../common/sorting";
import Breadcrums from "../../../common/breadcrumbs";
import Chart from "react-apexcharts";
import {
    capitalizeFirstLetter,
    formateDateWithMonth,
    removeSpecialCharacter,
    TrimText,
    writeMyExcel,
} from "../../../../../utils/commonfunction";
import { Placeholder, Tooltip, Whisper } from "rsuite";
import { AssociateReportList } from "../../../services/reports.sevices";
import ReportCharts from "../reportCharts";
const UserReportsTable = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: "Associate Reports", url: "" },
    ];
    const [resetdate, setResetDate] = useState(false);
    const [statusUpdated, setStatusUpdated] = useState(false);
    const [downloadReport, setDownloadReport] = useState(false);
    const [filter, setFilter] = useState("30d");


    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                AssociateReportList(formData)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        setList(
                            (data && data.data && data.data.list ? data.data.list : []).filter(
                                (item) => !(Array.isArray(item.role) && item.role[0] === "babe_user")
                            )
                        );
                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        setLoader(false);
                        console.log("error ====> ", error);
                    });
            }
        }, 300);
        return () => clearTimeout(getData)
    }, [
        location,
        statsupdate,
        sorting,
        search,
        globalsearch,
        itemperpage,
        params.pgno,
        statusUpdated
    ]);

    const handleExportToExcel = () => {
        setDownloadReport(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", datalength);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        AssociateReportList(formData)
            .then((data) => {
                setDownloadReport(false);
                const headers = [
                    t("Name"),
                    t("Email"),
                    t("Phone Number"),
                    t("Registration Date"),
                    t("Gender"),
                    t("Associate Address"),
                    t("Associate Bio"),
                    t("Associate Experience"),
                    t("Date of Birth"),
                    t("Preferred Services"),

                    t("Status"),
                    t("Registration Status"),
                    t("User Deactivated"),
                    t("Associate Verified"),
                    t("Training Video Completion (%)"),
                    t("Associate Status"),
                    t("Associate License Number"),
                    t("Associate License Expiry Date"),
                    t("Associate Serving Distance (in miles)"),
                    t("Associate Deactivated"),
                    t("Background Check Status"),
                    t("Background Check Result"),
                    t("Deleted"),
                    t("Created At"),
                ];
                const boolToText = (val) =>
                    val === true ? "Yes" : val === false ? "No" : "N/A";

                const statusToText = (val) =>
                    val === 1 ? "Active" : val === 0 ? "Inactive" : "N/A";

                const rows = data.data.list.map((row) => {
                    let services = "N/A";
                    if (Array.isArray(row?.associate_preferred_services)) {
                        services = row.associate_preferred_services
                            .map((service) => {
                                const subcats = (service.subcategorydata || [])
                                    .map((sub) => sub.title)
                                    .join(", ");
                                return subcats
                                    ? `${service.title} (${subcats})`
                                    : service.title;
                            })
                            .join(", ");
                    }

                    let experience = "N/A";
                    if (
                        row?.associate_experience !== undefined &&
                        row?.associate_experience !== null
                    ) {
                        const expNum = Number(row.associate_experience);
                        if (!isNaN(expNum)) {
                            experience = expNum === 1 ? `${expNum} year` : `${expNum} years`;
                        }
                    }

                    return [
                        row?.name ?? "N/A",
                        row?.email ?? "N/A",
                        row?.phone_number ?? "N/A",
                        row?.registration_date
                            ? new Date(row.registration_date).toLocaleDateString()
                            : "N/A",
                        row?.gender ? capitalizeFirstLetter(row.gender) : "N/A",
                        row?.associate_address?.address ?? "N/A",
                        row?.associate_bio ?? "N/A",
                        experience,
                        row?.date_of_birth
                            ? new Date(row.date_of_birth).toLocaleDateString()
                            : "N/A",
                        services,

                        statusToText(row?.status),
                        boolToText(row?.registration_status),
                        boolToText(row?.isUserDeactivated),
                        boolToText(row?.associate_verified),
                        row?.associate_training_video_completion ?? "N/A",
                        statusToText(row?.associate_status),
                        row?.associate_license_number ?? "N/A",
                        row?.associate_license_expiry_date
                            ? new Date(row.associate_license_expiry_date).toLocaleDateString()
                            : "N/A",
                        row?.associate_serving_distance ?? "N/A",
                        boolToText(row?.isAssociateDeactivated),
                        row?.backgroundCheckStatus ?? "N/A",
                        row?.backgroundCheckResult ?? "N/A",
                        boolToText(row?.is_deleted),
                        row?.createdAt
                            ? new Date(row.createdAt).toLocaleDateString()
                            : "N/A",
                    ];
                });

                writeMyExcel([headers, ...rows], `${t('Associate report')}.xlsx`);
            })
            .catch((error) => {
                setDownloadReport(false);
                console.log("error ====> ", error);
            });

    };

    const viewfunction = (row) => {
        navigate(
            `/admin/reports/associate-reports/view/${row._id}`
        );
    };

    // sorting function start
    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };
    // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };


    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        // $("#defaultstatus")[0].selectedIndex = 0;
    };
    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* Below section has code of charts */}
            <div className="min-h-screen w-full bg-gray-50 p-6">
                <div className="mx-auto max-w-6xl space-y-6">
                    {/* Dropdown Filter */}
                    <div className="mb-4 flex items-center space-x-2">
                        <label className="mr-2 font-medium text-gray-700">Select Duration:</label>
                        <select
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            className="px-4 py-2 rounded-xl border border-gray-300 bg-white shadow-md text-gray-700 
                                    focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500
                                    transition duration-200 ease-in-out hover:border-indigo-400"
                        >
                            <option value="7d">Last 7 Days</option>
                            <option value="30d">Last 30 Days</option>
                            <option value="90d">Last 90 Days</option>
                            <option value="all">All</option>
                        </select>
                    </div>
                    <ReportCharts filter={filter} From={"RegistrationsAssociate"} />
                </div>
            </div>

            {/* Below section has code of table */}
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">
                                User Reports
                            </h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="me-3">
                                    <StatusFilter data={USER} prepareSearch={prepareSearch} />
                                </div> */}
                                <button
                                    type="button"
                                    onClick={() => { handleExportToExcel() }}
                                    className="btn ripple btn-main-primary signbtn"
                                    disabled={downloadReport}
                                >
                                    {t("btn_export_report")}
                                </button>
                                <button
                                    type="reset"
                                    value="Reset"
                                    onClick={resetFilter}
                                    className="btn ripple btn-main-primary signbtn ms-2"
                                >
                                    {t("btn_reset_filter")}
                                </button>
                            </div>
                        </div>
                        {loader ?
                            <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            :
                            <>
                                <div className="table-responsive min-h-400">
                                    <table className="table table-bordered card-table border-top text-nowrap w-100">
                                        <thead>
                                            <tr>
                                                <th className="position-relative select_head">
                                                    <span>{t("list_heading_sno")}</span>
                                                </th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("label_name")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="name"
                                                        />
                                                    </div>
                                                </th>
                                                <th>{t("label_email")}</th>
                                                <th>
                                                    <div className="sorting_column">
                                                        <span>{t("list_heading_address")}</span>
                                                        <Sorting
                                                            sort={sorting}
                                                            handleSort={handleSort}
                                                            column="location"
                                                        />
                                                    </div>
                                                </th>
                                                <th>{t("Role")}</th>
                                                <th className="">{t("label_phone_number")}</th>
                                                <th className="created_head">
                                                    <div className="sorting_column">
                                                        <span>{t("list_heading_created_date")}</span>
                                                    </div>
                                                </th>
                                                <th className="action_head">{t("list_heading_action")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <>
                                                {list.length ? (
                                                    list.map((row, i) => {
                                                        return (
                                                            <tr
                                                                key={i}
                                                            >
                                                                <td>
                                                                    {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                                                </td>

                                                                <td>{row?.name ? <div className="d-flex">{row?.name ? TrimText(capitalizeFirstLetter(row?.name), 20) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                                                                <td>{row?.email ? row.email : "N/A"}</td>

                                                                <td>{row?.address && row?.address.address ? TrimText(capitalizeFirstLetter(row?.address.address, 30)) : "N/A"} </td>

                                                                <td className="text-capitalize">
                                                                    {row?.role ? (
                                                                        <span
                                                                            className={`badge badge-pill ${row.role.includes("babe_user") ? "badge-success-light" : row.role.includes("babe_associate")
                                                                                ? "badge-info-light"
                                                                                : "badge-secondary"
                                                                                }`}
                                                                        >{removeSpecialCharacter(row.role)} </span>
                                                                    ) : ("N/A")}
                                                                </td>
                                                                <td>{row?.phone_number ? row.phone_number : "N/A"}</td>
                                                                <td>
                                                                    {row?.createdAt
                                                                        ? formateDateWithMonth(row.createdAt)
                                                                        : "N/A"}
                                                                </td>
                                                                <td>
                                                                    <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                                                        <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                                                                <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                                                                    <i className="ri-eye-fill"></i>
                                                                                </button>
                                                                            </Whisper>
                                                                        </div>
                                                                    </div>

                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={14} className="text-center">
                                                            {t("msg_no_records")}
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        </tbody>
                                    </table>
                                </div>
                                <div
                                    className=""
                                    id="example1_info"
                                    role="status"
                                    aria-live="polite"
                                >
                                    <b>
                                        {t("msg_total_records")} : {datalength ? datalength : "0"}
                                    </b>
                                </div>
                                {datalength && datalength > 0 ? (
                                    <CustomPagination
                                        datalength={datalength}
                                        itemperpage={itemperpage}
                                        currentPage={page}
                                        setPage={setPage}
                                        pageRoute={[
                                            {
                                                name: "Reataurant",
                                                path: "/admin/reports/associate-reports/list",
                                            },
                                        ]}
                                    />
                                ) : (
                                    ""
                                )}
                            </>
                        }
                    </div>
                </div>
            </div>

        </>
    );
};

export default UserReportsTable;
